import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#44403c",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.67",
      d: "M17.5 7.5a2 2 0 0 0-.588-1.422l-2.99-2.99A2 2 0 0 0 12.5 2.5H4.167A1.667 1.667 0 0 0 2.5 4.167v11.666A1.667 1.667 0 0 0 4.167 17.5h11.666a1.667 1.667 0 0 0 1.667-1.667z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#44403c",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.67",
      d: "M12.5 2.5v4.167a.833.833 0 0 0 .833.833H17.5"
    }, null, -1)
  ]))]))
}
export default { render: render }